import { createSlice } from "@reduxjs/toolkit";
import { fetchUserTasks } from "./taskThunks";

const initialState = {
    tasks: [],          // array of task objects
    total: 0,           // total row count from server (for pagination)
    loading: false,     // true while fetchUserTasks is in-flight
    error: null,        // string error message, or null
};

const taskSlice = createSlice({
    name: "tasks",
    initialState,
    reducers: {
        clearTasks: (state) => {
            state.tasks = [];
            state.total = 0;
            state.error = null;
            state.loading = false;
        },
        updateTaskStatus: (state, action) => {
            const { id, status } = action.payload;
            state.tasks = state.tasks.map((t) =>
                String(t.id) === String(id) ? { ...t, status } : t
            );
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserTasks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserTasks.fulfilled, (state, action) => {
                state.loading = false;
                const payload = action.payload;

                // Extract array — try every common response shape
                let list = [];
                if (Array.isArray(payload)) {
                    list = payload;
                } else if (payload && typeof payload === "object") {
                    list = Array.isArray(payload.items) ? payload.items
                        : Array.isArray(payload.tasks) ? payload.tasks
                        : Array.isArray(payload.data?.tasks) ? payload.data.tasks
                        : Array.isArray(payload.data) ? payload.data
                            : Array.isArray(payload.results) ? payload.results
                                : Array.isArray(payload.rows) ? payload.rows
                                    : [];
                }

                state.tasks = list;
                state.total = (payload?.pagination?.totalItems ?? payload?.data?.pagination?.totalItems ?? payload?.total ?? payload?.data?.total ?? list.length);
            })
            .addCase(fetchUserTasks.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? "Failed to fetch tasks";
            });
    },
});

export const { clearTasks, updateTaskStatus } = taskSlice.actions;
export default taskSlice.reducer;
